import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import { AuthWrapper, ErrorWrapper } from "wrappers";
import { Layout } from "containers";
import { icons } from "assets/icons";
import { Spinner } from "components";
import "utils/mixpanel"; // Initialize Mixpanel
import AccessDeniedBanner from "components/AccessDeniedBanner";

React.icons = icons;

const LoginView = React.lazy(() => import("./pages/Auth/views/Login.view"));
const ErrorView = React.lazy(() => import("./pages/Home/UI/Page500.view"));
const IFrameTokenShare = React.lazy(() => import("./pages/IFrameTokenShare"));
const SubAdminCareHomesPage = React.lazy(() => import("./pages/SubAdmins/UI/MyCareHomesPage"));
const ResetPasswordView = React.lazy(() =>import("./pages/Auth/views/ResetPassword.view"));
const ForgotPasswordView = React.lazy(() => import("./pages/Auth/UI/ForgotPassword/ForgotPassword.jsx"));
const SubscriptionSuccess = React.lazy(() =>import("./pages/Users/UI/SubscriptionSuccess"));
const SubscriptionAccess = React.lazy(() => import("./pages/Subscription/UI/SubscriptionAccess"));

function App() {
  return (
    <>
 
    <AccessDeniedBanner />
    
    <Suspense fallback={<Spinner grow />}>
      <Switch>
        <Route
          path="/login"
          name="Login"
          render={(props) => <LoginView {...props} />}
        />
        <Route
          exact
          path="/forgot-password"
          name="Forgot Password"
          render={(props) => <ForgotPasswordView {...props} />}
        />
        <Route
          exact
          path="/reset-password"
          name="Reset Password"
          render={(props) => <ResetPasswordView {...props} />}
        />
        <Route path="/500" name="Error" render={() => <ErrorView />} />
        <Route path="/token-share" render={() => <IFrameTokenShare />} />
        <Route path="/sub-admin-care-homes/:subAdminId" render={(props) => (
          <AuthWrapper>
            <SubAdminCareHomesPage {...props} />
          </AuthWrapper>
        )}
        />
        <Route
          exact
          path="/subscription/success"
          name="Subscription Success"
          render={(props) => <SubscriptionSuccess {...props} />}
        />
        <Route
          exact
          path="/subscription/:encodedContact"
          name="Manage Subscription"
          render={(props) => <SubscriptionAccess {...props} />}
        />
        <Route
          path="/"
          name="Home"
          render={(props) => (
            <AuthWrapper>
              <ErrorWrapper>
                <Layout {...props} />
              </ErrorWrapper>
            </AuthWrapper>
          )}
        />
        <Route path="*" render={() => <NoMatch />} />
      </Switch>
    </Suspense>
    </>
  );
}

const NoMatch = () => {
  return <p>There's nothing here: 404!</p>;
};

export default App;
